import {
  show_list_default
} from "./chunk-RISJWQCM.js";

// src/layouts/calendar/as-list.tsx
import Button from "@a24/ui/Button";
import { format, isPast } from "date-fns";
import { useHits } from "react-instantsearch";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
function groupByDate(items) {
  const dates = [];
  const filteredItems = items.filter((item) => {
    return !isPast(new Date(item?.startDate?.toString()));
  });
  for (let i = 0; i < filteredItems.length; i++) {
    const item = filteredItems[i];
    if (!item) {
      return;
    }
    const day = dates.find((day2) => day2.date === item?.startDate?.toString());
    if (day) {
      day.items.push(item);
    } else {
      dates.push({
        items: [item],
        date: item.startDate.toString()
      });
    }
  }
  return dates;
}
var ShowsList = () => {
  const { items } = useHits();
  const dates = groupByDate(items);
  return /* @__PURE__ */ jsx(Fragment, { children: dates.map((day, index) => /* @__PURE__ */ jsx(
    show_list_default,
    {
      day: format(day.date, "EEEE"),
      items: day.items,
      title: format(day.date, "MMM d")
    },
    index + day.date.toString()
  )) });
};
var AsList = ({
  className,
  id,
  isButtonDisabled,
  labels,
  handleMoreClick
}) => {
  return /* @__PURE__ */ jsxs("div", { className: `${className} flex items-center flex-col`, id, children: [
    /* @__PURE__ */ jsx(ShowsList, {}),
    !isButtonDisabled && /* @__PURE__ */ jsx(
      Button,
      {
        label: labels?.loadMore,
        onClick: handleMoreClick,
        disabled: false,
        className: "button-secondary mt-4"
      }
    )
  ] });
};
var as_list_default = AsList;

export {
  as_list_default
};
